import React from "react";

// import { Container } from './styles';

function ExamRequest() {
  return <div>ExamRequest</div>;
}

export default ExamRequest;
